// @flow
import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Tracking } from 'web-core/src/tracking';
import BenefitSection from 'client/components/benefitSection';
import HeroContainer from 'client/components/heroContainer';
import InputDrug from 'client/components/form/inputDrug';
import LinkButton from 'client/components/button/linkButton';
import ROUTES from 'client/constants/routes';

import type { HeroType, BenefitsType, PromoType } from 'types/contentful.flow';
import '../styles/prescriptions.scss';

type Props = {
  contentfulData: {
    hero: $Exact<HeroType>,
    benefits: $Exact<BenefitsType>,
    promo: $Exact<PromoType>,
  },
  isEnterpriseProvisioned: boolean,
  isLoggedIn: boolean,
  isProvisionEnable: boolean,
};

class PrescriptionsPage extends PureComponent<Props> {
  render() {
    const { contentfulData, isEnterpriseProvisioned, isProvisionEnable, isLoggedIn } = this.props;
    const { hero, benefits, promo } = contentfulData;
    const redirectRoute = isLoggedIn && !isProvisionEnable ? '' : '/join/login?redirect=';

    // TOOD: allow the redirect prop to take more query params, only supports redirect now

    return (
      <div className="landing-container">
        <HeroContainer base="coverage" {...hero}>
          <InputDrug
            className="focus-white-color"
            buttonStyle={{}}
            buttonContents={<span className="pad">{_.get(hero, 'ctaButton')}</span>}
            buttonClassName="button primary pad"
            redirect={`${isEnterpriseProvisioned ? '' : redirectRoute}`} />
        </HeroContainer>
        <BenefitSection {...benefits} />
        <hr />
        <section className="promo-container">
          <div className="large-8 promo-content pad-right-2">
            <h2 className="pad-y-2">{_.get(promo, 'title')}</h2>
            <p className="margin-bottom-2">{_.get(promo, 'info')}</p>
            <LinkButton
              href={ROUTES.HEALTH_PROFILE_LOCATION_PATH}
              className="cta-button margin-bottom-2"
              onClick={() => {
                Tracking.track('CTA: Shop for a plan');
              }}>
              <span>{_.get(promo, 'ctaButton')}</span>
            </LinkButton>
          </div>
          <div className="large-4 promo-img">
            <img className="iphone" src={_.get(promo, 'imgSrc')} alt="phone screenshot" />
          </div>
        </section>
      </div>
    );
  }
}

export default PrescriptionsPage;
